import React from "react";
import ReactApexChart from "react-apexcharts";

const AvgProfitLoss = ({ PositiveDays, NegativeDays }) => {
  const series = [
    {
      type: "bar",
      data: [PositiveDays, NegativeDays],
    },
  ];

  const options = {
    colors: ["#04D9FF", "#FD504F"],
    fill: {
      colors: ["#04D9FF", "#FD504F"],
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: undefined,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },

    plotOptions: {
      bar: {
        borderRadius: 10,
        columnWidth: "70%",
        distributed: true,
      },
    },

    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "bar",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 4,
    },
    grid: {
      borderColor: "#415672",
      strokeDashArray: 8,
    },
    xaxis: {
      seriesName: "No. of trades",
      categories: ["Positive", "Negative"],
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        rotate: -45,
        style: {
          colors: "#ffffff",
          fontSize: "14px",
          fontWeight: 700,
        },
      },
    },
    yaxis: [
      {
        seriesName: "Balance",
        labels: {
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
    ],
    tooltip: {
      enabled: false,
    },
  };

  return (
    <div id="chart">
      <ReactApexChart options={options} series={series} height={420} />
    </div>
  );
};
export default AvgProfitLoss;
